export const keys = {
  chain: ['chain'] as const,
  providers: ['providers'] as const,
  provider: (address: string) => ['provider', address] as const,
  catalog: (filters: string) => ['catalog', filters] as const,
  capacityEnvelope: ['capacity-envelope'] as const,
  account: (address: string) => ['account', address] as const,
  deployments: (address: string) => ['deployments', address] as const,
  deployment: (address: string, dseq: string) => ['deployment', address, dseq] as const,
  leases: (address: string) => ['leases', address] as const,
  escrow: (address: string) => ['escrow', address] as const,
  bids: (address: string, dseq: string) => ['bids', address, dseq] as const,
  me: ['me'] as const,
  myIp: ['network', 'my-ip'] as const,
  identities: ['auth-identities'] as const,
  paymentsSummary: ['payments', 'summary'] as const,
  paymentsActivity: ['payments', 'activity'] as const,
  fundingIntent: (id: string) => ['payments', 'funding-intent', id] as const,
  redemption: (id: string) => ['payments', 'redemption', id] as const,
  operator: (resource: string) => ['operator', resource] as const,
  rentalCapability: (provider: string) => ['rental', 'capability', provider] as const,
  rentalOffers: (provider: string) => ['rental', 'offers', provider] as const,
  versions: ['versions'] as const,
  versionScan: (scanId: string) => ['versions', 'scan', scanId] as const,
  versionScanHistory: (limit?: number, cursor?: string) => ['versions', 'history', limit, cursor] as const,
}
